var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import styles from './SelectionControl.module.scss';
import { Tick } from '../../foundations/icons';
var SelectionControlComponent = function (_a, ref) {
    var checkMarkComponent = _a.checkMarkComponent, type = _a.type, props = __rest(_a, ["checkMarkComponent", "type"]);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("input", __assign({ ref: ref }, props, { type: type })),
        checkMarkComponent || (React.createElement("div", { className: cx('fakeInput', styles.fakeInput) },
            React.createElement("div", { className: styles.checkMark }, type === 'checkbox' && React.createElement(Tick, { size: "small" }))))));
};
export var SelectionControl = forwardRef(SelectionControlComponent);
//# sourceMappingURL=SelectionControl.js.map